// extracted by mini-css-extract-plugin
export default {"hotspotContainer":"hotspots_hotspotContainer__BeIE2","hotspot":"hotspots_hotspot__hxd++","large":"hotspots_large__K5XEr","dragging":"hotspots_dragging__aKfUd"};